import React, { useEffect } from 'react';
import './PageLoader.css';

const PageLoader = ({ onComplete }) => {
  useEffect(() => {
    const t = setTimeout(() => {
      if (onComplete) onComplete();
    }, 5200);

    return () => clearTimeout(t);
  }, [onComplete]);

  return (
    <div className="page-loader" role="status" aria-label="Loading page">
      <div className="loader-logo-center">
        <div className="loader-logo-wrap">
          <img
            src="/logo.png"
            alt="Data Bolta Hai"
            className="loader-logo-img"
          />
        </div>
      </div>

      <div className="loader-progress-bottom">
        <div className="loader-progress-track">
          <div className="loader-progress-bar" />
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
